export default "__VITE_PUBLIC_ASSET__cba541ce__"